import { useState } from 'react';
import { getFormDefaultValue, getTableHeaders } from '../../utils/forms/FormDataModel';
import AbstractLanding from '../Entity/AbstractLanding';
import AbstractTabs, { TabActiosEventType, TabActiosProps } from '../Entity/AbstractTabs';
import { PARTNER_ORDER_MEMBERS } from '../../constants/EntityName';
import { partnerOrderMembersFormData } from '../../datamodels/PartnerOrderMembers';
import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import AbstractForm from '../Entity/AbstractForm';
import { ContentItem, OnAddArguments } from '../../utils/forms/FormInterface';

const PartnerOrderMembers = () => {
  const [activeKey, setActiveKey] = useState<string>('0');
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [content, setContent] = useState<any>([]);

  const tableHeaders: any = getTableHeaders(partnerOrderMembersFormData);
  const headerName = 'Partner Order Members';

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType
  ) => {
    if (action === 'remove') {
      onTabClick('0');
      setContent((content: any) => content.filter((item: any) => String(item.key) !== targetKey));
    }
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent((content: any) => content.filter((item: any) => item.key !== key));
    setActiveKey('0');
    shouldRefresh && setRefreshData(prev => !prev);
  };

  const onSuccessful = (id?: string) => {
    onTabClick('0');
    setRefreshData(prev => !prev);
  };

  const onAdd = (argument1: OnAddArguments) => {
    const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
    if (checkArr.length) {
      setActiveKey(String(argument1.id));
      return;
    }

    const newObj = {
      key: argument1.id,
      tabTitle: argument1.id, // Or use member name if available
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            headerName={headerName}
            entityName={PARTNER_ORDER_MEMBERS}
            formTemplate={partnerOrderMembersFormData}
            formDefaultPayload={getFormDefaultValue(partnerOrderMembersFormData)}
            onSuccessfulUpdate={onSuccessful}
            formHeader=""
            showDeleteDraft={false}
            closeTab={closeTab}
          />
        </GenericAccordian>
      ),
    };

    setContent((prev: any) => [...prev, newObj]);
    argument1.id && setActiveKey(String(argument1.id));
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1) {
      onAdd(argument1);
    }
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName={headerName}
      updateFormVisibility={updateFormVisibility}
      onTabClick={onTabClick}
      showFormComponent={false}
      content={content}
    >
      <AbstractLanding
        headerName={headerName}
        entityName={PARTNER_ORDER_MEMBERS}
        tableHeaders={tableHeaders}
        refreshData={refreshData}
        onAdd={onAddNew}
        disableAdd={true}
      />
    </AbstractTabs>
  );
};

export default PartnerOrderMembers;
